/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type GoalOverviewProgressStatus = (typeof GoalOverviewProgressStatus)[keyof typeof GoalOverviewProgressStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GoalOverviewProgressStatus = {
  in_progress: "in_progress",
  completed: "completed",
} as const;
